// source: system/application/views/widgets/moreCategories.php
/**
 * Script for secondary category slider at secondaryCategory.php widget.
 */
$(() => {
    // Variables declaration for use in secondary category slider
    const wrapper = document.querySelector('.cards-wrapper');
    const allCards = document.querySelectorAll('.cards-wrapper .card');
    let lastPixels = 0;
    let visibleCardCount = 4;
    const extraSpaceCount = 5;
    let displayAreaForLastMinus = 5;
    let clickedDotNum = 1;
    let pixels = 0;

    // Catch the next & previous button
    const next = document.querySelector('.slider-action-buttons .next');
    const previous = document.querySelector('.slider-action-buttons .previous');

    // Hide the previous button by default - FIXED: Check for null, not just undefined
    if (previous && clickedDotNum === 1) {
        previous.classList.add("hidden-element");
    }

    // Hide the next button on condition - FIXED: Check for null
    if (next && (allCards.length < visibleCardCount || clickedDotNum === (allCards.length - visibleCardCount))) {
        next.classList.add("hidden-element");
    }

    // On click previous button event handler - FIXED: Check for null
    if (previous) {
        previous.addEventListener('click', (e) => {
            const displayArea = allCards[0].clientWidth + extraSpaceCount;
            if (clickedDotNum === 0) {
                return;
            }
            clickedDotNum--;
            pixels = -displayArea * clickedDotNum;
            wrapper.style.transform = `translateX(${pixels}px)`;
            if (clickedDotNum === 0) {
                previous.classList.add("hidden-element");
                clickedDotNum++;
            }
            next.classList.remove("hidden-element");
        });
    }

    // On click next button event handler - FIXED: Check for null
    if (next) {
        next.addEventListener('click', (e) => {
            if (wrapper.clientWidth < 570) {
                visibleCardCount = 3;
                displayAreaForLastMinus = 4;
            }
            if (wrapper.clientWidth < 500) {
                visibleCardCount = 2;
                displayAreaForLastMinus = 3;
            }

            // To hide the extra space  
            let displayArea = allCards[0].clientWidth + extraSpaceCount;
            if (clickedDotNum === (allCards.length - visibleCardCount)) {
                displayArea = allCards[0].clientWidth + extraSpaceCount;
                const displayAreaForLast = (displayArea * displayAreaForLastMinus) - wrapper.clientWidth;
                next.classList.add("hidden-element");
                pixels = (lastPixels - displayAreaForLast);
                wrapper.style.transform = `translateX(${pixels}px)`;
                return;
            } else {
                if (previous) previous.classList.remove("hidden-element");
                pixels = (-displayArea * clickedDotNum);
                wrapper.style.transform = `translateX(${pixels}px)`;
                lastPixels = pixels;
                clickedDotNum++;
            }
        });
    }
});